import { useRef, useState } from "react";
import Form from "../../../form/Form";
import { useDispatch, useSelector } from "react-redux/es/exports";
import useFileSelected from "./../../../../utils/hooks/useFileSelected";
import useInputChange from "./../../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../../utils/validators/validators";
import { addStaffGuarantorInfo } from "../../../../redux/slice/staff/staffSlice";
import { useEffect } from "react";
import PhoneInput from "react-phone-number-input";

const AddGuarantor = ({ id, appId }) => {
  const [error, setError] = useState({});
  const [editing, setEditing] = useState(false);

  const { staff_records, isSuccess, isLoading } = useSelector(
    (state) => state.staff
  );

  const [staffInputData, setStaffInputData] = useState({
    fullname: "",
    phone_number: "",
    address: "",
    relationship_with_staff: "",
    years_known_staff: "",
    working_segment: "",
    image: {},
    creating: "adding-new-gaurantor",
  });
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );
  const [fileInput, fileChangeHandler] = useFileSelected(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  const dispatch = useDispatch();
  const passportRef = useRef();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("#fa5c7c");
      setErrorMessage("Phone number is required.");
    } else {
      setBorderColor("");
      setErrorMessage("");
      setPhoneNumber(phone_no);
    }
    setStaffInputData(staffInputData);
  };

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!phoneNumber) {
        setBorderColor("#fa5c7c");
        setErrorMessage("Please enter phone number");
        return;
      }
      dispatch(
        addStaffGuarantorInfo({
          ...staffInputData,
          phone_number: phoneNumber,
        })
      );
    }
  };

  useEffect(() => {
    setStaffInputData({ ...staffInputData, app_id: appId });
  }, [appId]);

  useEffect(() => {
    if (isSuccess) {
      window.location.reload();
    }
  }, [staff_records]);

  return (
    <div
      className='modal fade'
      id={id}
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='staticBackdropLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='staticBackdropLabel'>
              Add New Guarantor
            </h5>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-hidden='true'
              onClick={() => setEditing(false)}
            ></button>
          </div>
          <div className='modal-body'>
            <Form
              setError={(e) => {
                if (!phoneNumber) {
                  setBorderColor("#fa5c7c");
                  setErrorMessage("Please enter phone number");
                }
                setError(e);
              }}
              submitHandler={handleSubmit}
              values={staffInputData}
            >
              <div className='row g-'>
                <div className='mb-0 col-md-6'>
                  <label htmlFor='inputEmail4' className='form-label'>
                    Full Name
                  </label>
                  <input
                    min='3'
                    textname='full name'
                    name='fullname'
                    onChange={handleChange}
                    value={input.fullname}
                    type='text'
                    className={`form-control ${error.fullname && "is-invalid"}`}
                    id='inputEmail4'
                    placeholder='Full Name'
                  />
                  {error.fullname && (
                    <span className='invalid-feedback'>{error.fullname}</span>
                  )}
                </div>
                <div className='col-md-6 mb-3'>
                  <label htmlFor='phone' className='form-label'>
                    Phone Number
                  </label>
                  <PhoneInput
                    placeholder='Enter phone number'
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setBorderColor("#fa5c7c");
                        setErrorMessage("Phone number is required.");
                      } else {
                        setBorderColor("");
                        setErrorMessage("");
                      }
                    }}
                    defaultCountry='NG'
                    className='form-control custom-phone-input'
                    style={{ borderColor: `${borderColor}` }}
                  />
                  {errorMessage && (
                    <span
                      className='text-danger text-sm'
                      style={{ fontSize: "12px" }}
                    >
                      {errorMessage}
                    </span>
                  )}
                </div>
              </div>

              <div className='row g-2'>
                <div className='mb-3'>
                  <label htmlFor='address' className='form-label'>
                    Address
                  </label>
                  <textarea
                    textname='address'
                    rows='3'
                    name='address'
                    value={input.address}
                    onChange={handleChange}
                    id='address'
                    className={`form-control ${error.address && "is-invalid"}`}
                    placeholder='Enter address here'
                  ></textarea>
                  {error.address && (
                    <span className='invalid-feedback'>{error.address}</span>
                  )}
                </div>
              </div>

              <div className='row g-'>
                <div className='col-lg-6 col-xl-4 col-md-12 mb-3'>
                  <label htmlFor='inputEmail4' className='form-label'>
                    Working Segment
                  </label>
                  <input
                    textname='working segment'
                    name='working_segment'
                    value={input.working_segment}
                    onChange={handleChange}
                    type='text'
                    className={`form-control ${
                      error.working_segment && "is-invalid"
                    }`}
                    placeholder='Working Segment (e.g business person, clergy, civil servant)'
                  />
                  {error.working_segment && (
                    <span className='invalid-feedback'>
                      {error.working_segment}
                    </span>
                  )}
                </div>
                <div className='col-lg-6 col-xl-4 col-md-12 mb-3'>
                  <label htmlFor='example-textarea' className='form-label'>
                    Relationship with staff
                  </label>
                  <input
                    textname='relationship'
                    name='relationship_with_staff'
                    value={input.relationship_with_staff}
                    onChange={handleChange}
                    id='relationship_with_staff'
                    className={`form-control ${
                      error.relationship_with_staff && "is-invalid"
                    }`}
                    placeholder='Relationship with staff'
                  />
                  {error.relationship_with_staff && (
                    <span className='invalid-feedback'>
                      {error.relationship_with_staff}
                    </span>
                  )}
                </div>
                <div className='col-lg-12 col-xl-4 col-md-12 mb-3'>
                  <label htmlFor='example-textarea' className='form-label'>
                    How long have you known the staff
                  </label>
                  <input
                    textname='year(s)'
                    name='years_known_staff'
                    value={input.years_known_staff}
                    onChange={handleChange}
                    id='years_known_staff'
                    className={`form-control ${
                      error.years_known_staff && "is-invalid"
                    }`}
                    placeholder='year'
                  />
                  {error.years_known_staff && (
                    <span className='invalid-feedback'>
                      {error.years_known_staff}
                    </span>
                  )}
                </div>
              </div>

              <div className='row g-2'>
                <div className='passport-container d-flex gap-4'>
                  <div className='input-wrapper'>
                    <label
                      className='btn btn-primary rounded-0'
                      htmlFor='passport'
                      onClick={() => {
                        passportRef.current.click();
                      }}
                    >
                      Choose Passport
                    </label>
                    <input
                      textname='passport'
                      className='d-none'
                      accept='image/*'
                      type='file'
                      name='image'
                      onChange={fileChangeHandler}
                      ref={passportRef}
                    />
                    {error.image && (
                      <span className='d-block text-danger mt-2'>
                        {error.image}
                      </span>
                    )}
                  </div>
                  <div className='passport mb-4'>
                    <img
                      src={staffInputData?.temp_url && staffInputData?.temp_url}
                      width='100'
                      alt=''
                    />
                  </div>
                </div>
              </div>

              <div className='float-end'>
                <a
                  type='button'
                  className='btn btn-secondary'
                  data-bs-dismiss='modal'
                  onClick={() => setEditing(false)}
                >
                  Close
                </a>
                <button
                  disabled={isLoading && true}
                  className='btn btn-primary w-10 ms-2'
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
          <div className='modal-footer'>
            {/* <a type="button" className="btn btn-secondary" data-bs-dismiss="modal"
                    onClick={() => setEditing(false)}
                    >Close</a>
                    <button className="btn btn-primary">
                        {
                            editing ? 'Update Record' : 'Add Record'
                        }
                    </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGuarantor;
